import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { User } from 'src/app/models/user';
import { UserRole } from 'src/app/models/userRoles';
import { UserRights } from 'src/app/models/userRights';
import { UserService } from 'src/app/shared/user/user-service.service';
import { RoleComponent } from '../role/role.component';
import { RightsTemplate } from 'src/app/models/rightsTemplate';
import { RightsTemplateComponent } from '../rights-template/rights-template.component';
import { AuthorsService } from 'src/app/shared/authors/authors.service';
import { pgiAuthors } from 'src/app/models/authors';
import { AuthorsListComponent } from '../authors-list/authors-list.component';

@Component({
  selector: 'app-detail-user',
  templateUrl: './detail-user.component.html',
  styleUrls: ['./detail-user.component.css']
})
export class DetailUserComponent implements OnInit {

  rola: UserRole[];
  rolaName: string;
  rights: UserRights[];
  // tslint:disable-next-line:max-line-length
  pgiAuthor: pgiAuthors = { id: 0, authorName: '<nie wybrano>', userId: 0, notes: '', archiwalny: false, notes2: '', pgiCalcHeader: null, accountBalance: 0, authorId: 0 };

  @ViewChild(RoleComponent)
  private roleComponent: RoleComponent;
  @ViewChild(RightsTemplateComponent)
  private rightsTemplateComponent: RightsTemplateComponent;
  @ViewChild(AuthorsListComponent)
  private authorsListComponent: AuthorsListComponent;

  constructor(public dialogRef: MatDialogRef<ModalWindowComponent>,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: User,
    private authorService: AuthorsService,
    public snackBar: MatSnackBar) {
     }

  ngOnInit() {
    this.GetUserRole();
    this.GetUserTemplate();
    this.GetAuthorByUserId(this.data.id);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  GetUserRole(): void {
    console.log('role - userid:');
    console.log(this.data.id);
    this.userService.getUserRole(this.data.id).subscribe(data => {
      console.log(data);
      if (data.length > 0) {
      this.rola = data;
      this.rolaName = this.rola[0].roleName;
      }
    });
  }

  GetUserTemplate(): void {
    this.userService.getUserRights(this.data.id).subscribe(data => {
      this.rights = data;
    });
  }

  changePassword(pass) {
    this.userService.changePassword(pass, this.data.id).subscribe(
      success => {
        console.log('zmiana hasła');
        console.log(success);
        this.openSnackBar(success.toString(), '');
      }
    );
  }

  changeRole() {
    console.log('change role');
    console.log(this.roleComponent.selectedValue);
    this.roleComponent.roles.forEach(x => {
       if (x.id === parseInt(this.roleComponent.selectedValue, 10)) {
          this.rolaName = x.roleName;
      }
    });
    // zaktualizować rolę w bazie
    this.userService.changeRole(this.roleComponent.selectedValue, this.data.id).subscribe(
      success => {
        console.log('zmiana roli');
        console.log(success);
        this.openSnackBar(success.toString(), '');
      }
    );
  }

  changeRights() {
    this.rights = [];
    this.rightsTemplateComponent.selectedValue.value.forEach(element => {

      // tslint:disable-next-line:max-line-length
      const right = { id: element.id, rightName: element.name, userId: this.data.id, rightId: element.id, read: element.read, write: element.write, execute: element.execute };
      console.log(right);
      this.rights.push(right);
    });
    // zaktualizować uprawnienia
    this.userService.changeRight(this.rights).subscribe(
      success => {
        console.log('success update author');
        console.log(success);
        this.openSnackBar(success.toString(), '');
    }
    );
  }

  GetAuthorByUserId(id) {
    this.authorService.getAuthorByUserId(id).subscribe(
      res => {
        if (res !== null) {
        this.pgiAuthor = res;
        console.log('get author by user id');
        console.log(res);
        }
      }
    );
  }

  changeAuthor() {
    this.authorsListComponent.authors.filter(x => x.authorName === this.authorsListComponent.selectedValue).forEach(x => {
      // tslint:disable-next-line:max-line-length
      this.pgiAuthor = { id: x.id, authorName: x.authorName, userId: this.data.id, notes: x.notes, archiwalny: x.archiwalny, notes2: x.notes, pgiCalcHeader: null, accountBalance: x.accountBalance, authorId: x.authorId };
    });
    this.userService.updateUserAuthor(this.pgiAuthor).subscribe(
      success => {
        console.log('success update author');
        console.log(success);
        this.openSnackBar(success, '');
    });
  }

  changeData() {
    console.log('user: ');
    console.log(this.data);

    this.userService.updateUser(this.data).subscribe(
      success => {
        console.log('success');
        console.log(success);
        this.openSnackBar('Zaktualizowano poprawnie dane podstawowe', '');
      },
         error => { this.openSnackBar('Problem z aktualizacją danych', '');
         console.log('error');
         console.log(error);
    }
    );

  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'top',
    });
  }

  deactivationAuthor() {
    this.userService.deactivationAuthor(this.pgiAuthor).subscribe(
      success => {
        console.log('success deactivation author');
        console.log(success);
        this.openSnackBar(success, '');
        // tslint:disable-next-line:max-line-length
        this.pgiAuthor = { id: 0, authorName: '<nie wybrano>', userId: 0, notes: '', archiwalny: false, notes2: '', pgiCalcHeader: null, accountBalance: 0, authorId: 0};
      }
    );
  }
}
